import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const sections = [
    {
      title: "1. Information We Collect",
      content: (
        <>
          <p>We collect personal and business information to deliver and improve our services.</p>
          <h4>a. Personal Information</h4>
          <ul>
            <li>Name, email address, phone number, company name, and designation.</li>
            <li>Payment or billing details when purchasing a service.</li>
          </ul>
          <h4>b. Technical Information</h4>
          <ul>
            <li>IP address, browser type, device ID, operating system, and referring URLs.</li>
            <li>Website usage patterns, analytics data, and session activity.</li>
          </ul>
          <h4>c. Business and Financial Data</h4>
          <ul>
            <li>Information shared for financial research, market intelligence, or performance reporting.</li>
            <li>Publicly available financial and corporate data used for analytics.</li>
          </ul>
        </>
      ),
    },
    {
      title: "2. How We Use Your Information",
      content: (
        <ul>
          <li>Deliver, manage, and improve our digital marketing and financial research services.</li>
          <li>Communicate with you regarding updates, reports, or service insights.</li>
          <li>Customize marketing campaigns and enhance user experience.</li>
          <li>Fulfill legal, regulatory, or contractual obligations.</li>
          <li>Analyze usage data to optimize business performance.</li>
        </ul>
      ),
    },
    {
      title: "3. Legal Basis for Processing (GDPR)",
      content: (
        <ul>
          <li>Consent – When you voluntarily provide data or subscribe to updates.</li>
          <li>Contract – To deliver the services you request.</li>
          <li>Legal Obligation – To comply with applicable laws.</li>
          <li>Legitimate Interests – For analytics, service improvement, or business communication.</li>
        </ul>
      ),
    },
    {
      title: "4. Data Rights (GDPR, CCPA, DPDP)",
      content: (
        <>
          <p>You have the right to:</p>
          <ul>
            <li>Access, correct, or delete your personal data.</li>
            <li>Request data portability.</li>
            <li>Withdraw consent at any time.</li>
            <li>Object to processing for marketing purposes.</li>
            <li>Request that we limit or stop processing your data.</li>
          </ul>
          <p>To exercise these rights, email us at <a href="mailto:collab@digitaledgermedia.com">collab@digitaledgermedia.com</a>. We will respond in accordance with applicable data protection laws.</p>
        </>
      ),
    },
    {
      title: "5. Sharing and Disclosure",
      content: (
        <ul>
          <li>Service providers assisting with hosting, analytics, marketing, or payment processing.</li>
          <li>Legal or regulatory authorities when required by law.</li>
          <li>Business partners or affiliates, under strict confidentiality agreements.</li>
          <li>In case of mergers or acquisitions, where your data is part of the transferred assets.</li>
        </ul>
      ),
    },
    {
      title: "6. International Data Transfers",
      content: (
        <p>We operate globally and may transfer your data to servers outside your country. All such transfers comply with applicable data protection laws, using adequate safeguards like Standard Contractual Clauses (SCCs) or equivalent mechanisms.</p>
      ),
    },
    {
      title: "7. Data Retention",
      content: (
        <p>We retain personal data only as long as necessary for the purpose collected, to comply with legal obligations, or to resolve disputes.</p>
      ),
    },
    {
      title: "8. Cookies and Tracking Technologies",
      content: (
        <>
          <p>We use cookies, tags, and analytics tools (such as Google Analytics) to:</p>
          <ul>
            <li>Improve website performance and user experience.</li>
            <li>Measure marketing effectiveness.</li>
            <li>Collect anonymized usage statistics.</li>
          </ul>
          <p>You can disable cookies via your browser settings, but some features may not function properly.</p>
        </>
      ),
    },
    {
      title: "9. Data Security",
      content: (
        <p>We employ administrative, technical, and physical safeguards to protect your data from unauthorized access, alteration, or destruction. Despite our efforts, no online transmission is 100% secure.</p>
      ),
    },
    {
      title: "10. Children’s Privacy",
      content: (
        <p>Our services are not directed to individuals under 18. We do not knowingly collect personal data from minors. If you believe a child has provided data, contact us for immediate removal.</p>
      ),
    },
    {
      title: "11. Updates to This Policy",
      content: (
        <p>We may revise this Privacy Policy periodically. Updates will be posted on this page with the latest “Last Updated” date.</p>
      ),
    },
    {
      title: "12. Contact Us",
      content: (
        <div className="privacy-contact">
          <p>If you have any questions or data-related requests, please contact:</p>
          <p><b>Digital Ledger Media</b></p>
          <p>📧 <a href="mailto:collab@digitaledgermedia.com">collab@digitaledgermedia.com</a></p>
          <p>🌐 <a href="https://digitalledgermedia.com" target="_blank" rel="noreferrer">https://digitalledgermedia.com</a></p>
          <p>📍 Delhi, India</p>
          <p>Data Controller: Digital Ledger Media</p>
        </div>
      ),
    },
  ];

  return (
    <div className="privacy-container">
      <div className="privacy-card">
        <h1 className="privacy-title mt-5">Privacy Policy</h1>
        <p className="privacy-subtitle">
          Effective Date: <b>November 7, 2025</b> • Last Updated: <b>November 7, 2025</b>
        </p>
        <p className="privacy-intro">
          Welcome to <b>Digital Ledger Media</b> (“we,” “our,” or “us”). We value your privacy and are committed to safeguarding your personal information. This Privacy Policy explains how we collect, use, store, and protect your data when you interact with our website <a href="https://digitalledgermedia.com" target="_blank" rel="noreferrer">digitalledgermedia.com</a>, our digital marketing services, or our financial intelligence and research solutions. By using our website or services, you agree to the practices described in this policy.
        </p>

        {sections.map((section, index) => (
          <div key={index} className="privacy-section">
            <h2>{section.title}</h2>
            <div>{section.content}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
